module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-46.0345cedc.png";